var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"release_main"},[_c('head-top',{attrs:{"head-title":"立即发布","torelease":"发布","goBack":"true"},on:{"torelease":_vm.addRelease}}),_vm._v(" "),_c('publish',{attrs:{"holder":_vm.holder},on:{"getValue":_vm.getValue,"getImage":_vm.getImage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff75b8e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Release.vue
// module id = 1ZeV
// module chunks = 0